import { recoilPersist } from "recoil-persist";

export const { persistAtom } = recoilPersist({
  key: "recoil-persist", // this key is using for local storage key
  storage: localStorage, // configuration for the storage to use; defaults to localStorage
});
